<template>
  <div class="home-tracks-store">
    <div class="col-xs-10 col-xs-offset-1 col-md-10 col-md-offset-1">
        <div class="info">
            <h3 v-text="store.title"></h3>
            <span class="shop-line"></span>
            <h4 v-html="store.description"></h4>
            <a :href="store.link" target="_blank" @click="onClickShopping">Go to Store</a>
            <ul>
                <li><strong v-text="store.item_1_name"></strong> {{ store.item_1_value }}</li>
                <li><strong v-text="store.item_2_name"></strong> {{ store.item_2_value }}</li>
            </ul>
        </div>
        <div class="background-gray"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TracksStore',
  dependencies: ['DATA'],
  data () {
    return {
      store: this.DATA.configs.store
    }
  },
  methods: {
    onClickShopping () {
      fbq('track', 'clickShopping');
    }
  }
}
</script>

<style scoped lang="scss">
  @import '../../../scss/variables';
  .home-tracks-store {
    height: 450px;
    position: relative;
    padding-top: 40px;
    margin-top: -16px;
    margin-bottom: 36px;
    color: $white;

    .info {
        background-image: url('/static/images/store.jpg');
        background-position: 50% 50%;
        height: 300px;
        border: 14px solid $white;
        padding: 20px 50px 20px;
        z-index: 2;
        position: relative;

        .shop-line {
          position: absolute;
          width: 40px;
          height: 2px;
          background: $white;
          left: 0;
          top: 47px;
        }

        h3 {
          font-size: 20px;
          font-family: $font-bold;
          margin-top: 20px;
        }

        h4 {
          font-size: 40px;
          margin-top: 10px;
          margin-bottom: 30px;
        }

        ul {
          position: absolute;
          right: 30px;
          bottom: 30px;
          li {
            line-height: 1.2em;
          }
          strong {
            font-family: $font-bold;
          }
        }
    }
    .background-gray {
        background-image: url('/static/images/store.jpg');
        background-position: 50% 50%;
        height: 450px;
        width: 100%;
        filter: grayscale(100%);
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
    }

    a {
      border: 2px solid $white;
      color: $white;
      background: transparent;
      font-size: 20px;
      font-family: $font-bold;
      outline: none;
      display: inline-block;
      cursor: pointer;
      text-decoration: none;
      text-align: center;
      padding: 20px 50px;
      color: transparent;
      background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%,rgba(255, 255, 255, 0) 50%,rgba(255, 255, 255, 1) 51%,rgba(255, 255, 255, 1) 100%);
      background-size: 100% 210%;
      background-position: top left;
      position: relative;
      transition: background 0.3s $easeInOutQuint, transform 0.3s $easeOutBack;

      @media screen and (max-width: 64em) {
        max-width: 85px;
      }

      &:after {
        content: "Go to Store";
        position: absolute;
        top: 0px;
        left: 0px;
        padding: 20px 50px;
        color: #000;
        opacity: 0;
        transform: translate3d(0px, 15px, 0px);
        transition: transform 0.3s $easeOutBack, opacity 0.3s linear;
      }

      &:before {
        content: "Go to Store";
        position: absolute;
        top: 0px;
        left: 0px;
        padding: 20px 50px;
        color: #fff;
        transition: transform 0.3s $easeOutBack, opacity 0.3s linear;
      }

      &:hover {
        &:after {
          transform: translate3d(0px, 0px, 0px);
          opacity: 1;
        }
        &:before {
          transform: translate3d(0px, -15px, 0px);
          opacity: 0;
        }
        background-position: 0% 100%;
      }
    }

    @media screen and (max-width: 64em) {
      .info {
        h4 {
          margin-top: 10px;
        }
      }
      ul {
        display: none;
      }
      a {
        display: block;
        margin: 0 auto;
        font-size: 14px;
        text-align: center;
        padding: 20px 50px;
      }
    }

    @media screen and (max-width: 48em) {
      .info {
        h4 {
          font-size: 30px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/Tracks/Store.vue